{
  "pageTitle": "Careers",
  "heroTitle1": "Join Our Journey",
  "heroTitle2": "To Inspire and Empower",
  "heroTitle3": "Future Leaders",
  "heroDescription": "Joining forces with Manara School will allow you to build a legacy behind by fostering the building of future leaders with the support of expert faculty who have extensive experience in realizing the potential of teenagers.",
  "cultureTitle1": "Culture and",
  "cultureTitle2": "Environment",
  "cultureText": "Members of Manara community are professional experts who love adolescents and are dedicated to their growth. They practice integrity, collaboration, empathy, and care. They operate within a framework of diversity, equity, and respect. They lead and learn with resilience and optimism.",
  "cultureButton": "Read our Portrait of an Educator",
  "benefits": "benefits",
  "andPolicies": "and policies",
  "exploreOur": "Explore our",
  "keyTeams": "key teams",
  "manaraCurrent": "CURRENT OPPORTUNITIES",
  "opportunities": "AT MANARA",
  "opportunitiesError": "Failed to get opportunities data",
  "careersCTA1": "Interested in Applying?",
  "careersCTA2": "Join Our Team",

  "heroAction": "Explore Jobs",

  "educationalTitle1": "Our Educational",
  "educationalTitle2": "Philosophy",
  "educationalText": "At Manara, education goes beyond academics to focus on personal growth, integrity, and purpose. Through a holistic approach, we offer individualized learning paths that honor each student’s unique strengths, foster inquiry-based learning to solve real-world problems, and promote global citizenship by embracing diversity and encouraging positive community impact.",

  "ourEducational": "Our Educational",
  "program": "Program",

  "join": "Join",
  "ourTeam": "Our Team",

  "apply": "Apply",
  "position": "Position",
  "location": "Location",
  "department": "Department",
  "type": "Type",
  "explore": "Explore Open",
  "oppurtunities": "Opportunities",

  "thankyou": "Thank You",
  "thankyouMessage": "Your application for has been successfully submitted. Our team will review your application thoroughly We appreciate your interest in joining Manara School and look forward to learning more about you.",
  "nameLabel": "Name",
  "namePlaceholder": "Name",
  "nameError": "Name is required!",
  "cvLabel": "CV",
  "cvPlaceholder": "Upload your CV",
  "cvError": "Cv is required!",
  "submit": "Submit Application",
  "messageLabel": "Anything  else you would like to add or share?",
  "messagePlaceholder": "Anything  else you would like to add or share?",

  "emailLabel": "Email",
  "emailPlaceholder": "example@example.com",
  "emailError": "Email should be ex@example.com",
  "emailRequired": "Email is required!",
  "phoneNumberLabel": "Phone Number",
  "phoneNumberPlaceholder": "010 000 000 00",
  "phoneNumberRequired": "Phone Number is required"
}
